exports.FormPayment = require('./formPayment');
